import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp, FaPlus } from "react-icons/fa";
import "../inputDropdownSimple/inputDropdownSimple.scss";
import "./inputDropdownAdd.scss";

const InputDropdownAdd = ({
    options = [],
    onSelect,
    onAddOption,
    value = "",
    placeholder = "Select an option",
    label = "Label",
    showLabel = true,
    required = false,
}) => {
    const [inputValue, setInputValue] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (value && typeof value === "object") {
            setInputValue(value.label || "");
        } else {
            setInputValue(value);
        }
    }, [value]);

    const handleInputClick = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const handleOptionClick = (option) => {
        setInputValue(option.label);
        onSelect(option);
        setIsOpen(false);
    };

    const handleAddOption = () => {
        onAddOption(inputValue);
        setInputValue(inputValue);
        setIsOpen(false);
    };

    useEffect(() => {
        if (inputValue) {
            setFilteredOptions(
                options.filter((option) =>
                    option.label && 
                    option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase().trim())
                )
            );
        } else {
            setFilteredOptions(options);
        }
    }, [inputValue, options]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setIsOpen(true);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const isAddOptionVisible =
        inputValue &&
        !options.some((option) =>
            option.label && option.label.toLowerCase().includes(inputValue.toLowerCase().trim())
        );

    return (
        <div className="input-dropdown-simple" ref={dropdownRef}>
            {showLabel && (
                <label className="input-dropdown-simple__label">
                    {label}
                    {required && (
                        <span className="input-dropdown-simple__required">
                            *
                        </span>
                    )}
                </label>
            )}
            <div className="input-dropdown-simple__wrapper">
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    placeholder={placeholder}
                    className={`input-dropdown-simple__input ${
                        isOpen ? "input-dropdown-simple__input--open" : ""
                    }`}
                    required={required}
                />
                <span className="input-dropdown-simple__icon">
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
            </div>
            {isOpen && (
                <div className="input-dropdown-simple__menu">
                    <ul
                        className="input-dropdown-simple__list"
                        onMouseDown={(e) => e.preventDefault()}
                    >
                        {filteredOptions.map((option, index) => (
                            <li
                                key={index}
                                className="input-dropdown-simple__list-item"
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                    {isAddOptionVisible && (
                        <div
                            className="input-dropdown-with-add__add-option"
                            onClick={handleAddOption}
                        >
                            <FaPlus /> Añadir "{inputValue}"
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InputDropdownAdd;
